import Vue from "vue";
import { RouteConfig } from "vue-router";

import { PermissionName } from "../../common/mixins/permission";
import ShopRegisterTMSPage from "../tms-shop-register/pages/ShopRegisterTMSPage.vue";

export const TMSRouter: (prefix?: string) => RouteConfig[] = (
  prefix = "TMS"
) => [
  {
    name: "ShopRegisterTMSPage",
    path: prefix,
    component: ShopRegisterTMSPage,
    meta: { title: "TMS Registeration" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.TMS_REGISTRATION
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  }
];
